import { useState } from "react";
import PropTypes from "prop-types";
import { CustomContainer, useDispatch } from "../../../atoms/DependencyHelper";
import FormInlineDetails from "../formInlineDetails/FormInlineDetails";
import CheckoutFormsModal from "../../../molecules/modals/checkoutFormsModal/CheckoutFormsModal";
import styles from "./DeliveryDetails.module.scss";
import { SET_SHIPPING } from "../../../../Redux/actionTypes/index";
import * as Analytics from "../../../../services/analyticsUtag";
import { getUpdatedSurname } from "../../../../utils/helperServices";

const DeliveryDetails = ({
  addressTypes,
  statesTypes,
  countryCode,
  countryName,
  shippingAddress,
  cartId,
  className,
  customerStatus,
  userLoggedIn,
  applicationType
}) => {
  const [modalType, setModalType] = useState("delivery");
  const [modalShow, setModalShow] = useState(false);

  const dispatch = useDispatch();

  const createStreetString = arr => {
    let res = "";

    if (arr && Array.isArray(arr) && arr.length > 0) {
      res = arr.join(", ");
    }
    return res;
  };

  const unitValue =
    shippingAddress &&
    shippingAddress?.unit_number &&
    shippingAddress?.unit_number !== "" &&
    shippingAddress?.complex_name &&
    shippingAddress?.complex_name !== ""
      ? shippingAddress.unit_number + " " + shippingAddress.complex_name + ", "
      : shippingAddress?.unit_number && shippingAddress?.unit_number !== ""
      ? shippingAddress.unit_number + ", "
      : shippingAddress?.complex_name && shippingAddress?.complex_name !== ""
      ? shippingAddress.complex_name + ", "
      : "";

  const streetValue =
    shippingAddress &&
    shippingAddress.street_number &&
    shippingAddress.street_number != "" &&
    shippingAddress.street
      ? shippingAddress.street_number +
        ", " +
        createStreetString(shippingAddress.street) +
        ", "
      : shippingAddress &&
        shippingAddress.street_number &&
        shippingAddress.street_number != ""
      ? shippingAddress.street_number + ", "
      : shippingAddress && shippingAddress.street
      ? createStreetString(shippingAddress.street) + ", "
      : "";

  const suburbValue =
    shippingAddress?.suburb && shippingAddress?.suburb !== ""
      ? shippingAddress.suburb + ", "
      : "";

  const townValue =
    shippingAddress?.town && shippingAddress?.town !== ""
      ? shippingAddress.town + ", "
      : "";

  const provinceValue =
    shippingAddress?.region && shippingAddress?.region?.label
      ? shippingAddress?.region?.label + ", "
      : "";

  const postalValue =
    shippingAddress?.postcode && shippingAddress?.postcode !== ""
      ? shippingAddress.postcode
      : "";

  const deliveryData = {
    value:
      shippingAddress && shippingAddress.address_name
        ? shippingAddress.address_name
        : "",
    subvalue:
      unitValue +
      streetValue +
      suburbValue +
      townValue +
      provinceValue +
      postalValue,
  };

  const contactDetailsData = {
    value:
      applicationType == "normal" &&
      shippingAddress &&
      shippingAddress.firstname &&
      shippingAddress.lastname
        ? shippingAddress.firstname +
          " " +
          getUpdatedSurname(shippingAddress.lastname)
        : "",
    subvalue:
      shippingAddress && shippingAddress.telephone
        ? shippingAddress.telephone
        : "",
  };

  const instructionsData = {
    value:
      shippingAddress && shippingAddress.instructions
        ? shippingAddress.instructions
        : "",
  };

  const getDeliveryType = type => {
    switch (type) {
      case "delivery":
        return "delivery address";
      case "contactDetails":
        return "contact person";
      default:
        return type;
    }
  };

  const showModal = type => {
    setModalType(type);
    setModalShow(true);

    Analytics.link({
      ...Analytics.getUtagData(),
      page_form_event: "start",
      page_form_name: `checkout: review order: ${customerStatus}: change ${getDeliveryType(
        type
      )}`,
    });
  };

  const hideModal = (refresh, results) => {
    setModalShow(false);

    if (refresh == true) {
      dispatch({
        type: SET_SHIPPING,
        payload: results,
      });
    }
  };

  return (
    <>
      <CustomContainer className={`${styles["main-details"]} ${className}`}>
        <FormInlineDetails
          className={`${styles["inline-details"]}`}
          type="delivery"
          applicationType={applicationType}
          title="Delivery address:"
          value={deliveryData.value}
          subvalue={deliveryData.subvalue}
          handleOnEdit={showModal}
        ></FormInlineDetails>
        <FormInlineDetails
          className={`${styles["inline-details"]}`}
          type="contactDetails"
          applicationType={applicationType}
          title={
            applicationType == "normal"
              ? "Contact person for delivery:"
              : "Contact number for delivery:"
          }
          value={contactDetailsData.value}
          subvalue={contactDetailsData.subvalue}
          handleOnEdit={showModal}
        ></FormInlineDetails>
        {/* 
        Don't delete it we will show it later
        
        <FormInlineDetails
          className={`${styles["inline-details"]}`}
          type="instructions"
          title="Special instructions:"
          value={instructionsData.value}
          subvalue={instructionsData.subvalue}
          handleOnEdit={showModal}
        ></FormInlineDetails> */}
      </CustomContainer>
      <CheckoutFormsModal
        show={modalShow}
        hide={hideModal}
        formType={modalType}
        variant="change"
        values={shippingAddress}
        addressTypes={addressTypes}
        statesTypes={statesTypes}
        countryCode={countryCode}
        countryName={countryName}
        cartId={cartId}
        step="review"
        pageName={`checkout: review order: ${customerStatus}`}
        isGuestUser={userLoggedIn ? false : true}
        applicationType={applicationType}
      ></CheckoutFormsModal>
    </>
  );
};

DeliveryDetails.propTypes = {
  addressTypes: PropTypes.array,
  statesTypes: PropTypes.array,
  countryCode: PropTypes.string,
  countryName: PropTypes.string,
  cartId: PropTypes.string,
  applicationType: PropTypes.string,
};

DeliveryDetails.defaultProps = {
  addressTypes: [],
  statesTypes: [],
  applicationType: "normal",
};

export default DeliveryDetails;
